import { render, staticRenderFns } from "./InspectionArchives.vue?vue&type=template&id=e0e6fe9c&scoped=true"
import script from "./InspectionArchives.vue?vue&type=script&lang=ts"
export * from "./InspectionArchives.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e6fe9c",
  null
  
)

export default component.exports